class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            this.initializeWishlistFeatures();
            this.initializeCompareButtons();
            this.initializeCountdown();

            // cart drawer ma  related product ma swiper slide mate
                setTimeout(() => {
                  if (typeof window.initializeSlider === 'function') {
                    window.initializeSlider();
                  }
                }, 500); 
             // cart drawer ma  related product ma swiper slide mate

          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }


  initializeWishlistFeatures() {
    // Reinitialize buttons and count specifically within this component
    const buttons = this.querySelectorAll(selectorss.button);
    if (buttons.length) {
      setupButtons(buttons);
    } else {
      console.warn('[Shopify Wishlist] No wishlist buttons found in related products.');
    }
    
    // Update wishlist count in case any changes occur during loading
    updateWishlistCount();
  }

  initializeCompareButtons() {
    // Initialize compare buttons specifically within this component
    const buttons = this.querySelectorAll(compareSelectors.button);
    if (buttons.length) {
      setupCompareButtons(buttons); // Reuse existing function to set up buttons
    } else {
      console.warn('[Shopify Compare] No compare buttons found in related products.');
    }
  }

  initializeCountdown() {
    const clockdivs = this.querySelectorAll('.clockdiv');

    clockdivs.forEach((clockdiv) => {
      const attrDate = new Date(clockdiv.getAttribute('data-date'));
      const now = new Date();

      if (now > attrDate) {
        clockdiv.style.display = 'none';
        return; // Skip further processing if the date has passed
      }

      const updateCountdown = () => {
        const distance = attrDate - new Date().getTime();
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (distance < 0) {
          clockdiv.style.display = 'none'; // Hide the countdown if it has expired
        } else {
          clockdiv.querySelector('.days').innerText = days;
          clockdiv.querySelector('.hours').innerText = hours;
          clockdiv.querySelector('.minutes').innerText = minutes;
          clockdiv.querySelector('.seconds').innerText = seconds;
        }
      };

      updateCountdown(); // Initial call to set values immediately
      const interval = setInterval(updateCountdown, 1000); // Update every second

      // Cleanup function to clear the interval if the element is removed
      const observer = new MutationObserver(() => {
        if (!document.contains(clockdiv)) {
          clearInterval(interval);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);
